// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3APtA","type":"styles_type__19gom","choices":"styles_choices__MBfDw"};